import { render, staticRenderFns } from "./headMenu1.vue?vue&type=template&id=6e875fae&scoped=true"
import script from "./headMenu1.vue?vue&type=script&lang=js"
export * from "./headMenu1.vue?vue&type=script&lang=js"
import style0 from "./headMenu1.vue?vue&type=style&index=0&id=6e875fae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e875fae",
  null
  
)

export default component.exports